/** @format */

export const COMPARE_PRODUCT_LIST_LIMIT = 5;
export const COMPARE_PRODUCT_LIST_SESSION_STORAGE_KEY = 'compareProducts';
export const COMPARE_PRODUCT_LIST_HIDE_FEATURE_SESSION_STORAGE_KEY = 'hideCompareProducts';
